import { PaymentElement, useElements, useStripe } from '@stripe/react-stripe-js'
import Button from '../../../components/Button'
import React, { FormEvent } from 'react'
import { useTranslation } from 'react-i18next'

const AddPaymentMethod = () => {
    const stripe = useStripe()
    const elements = useElements()
    const { t } = useTranslation(['settings'])
    const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault()
        if (!stripe || !elements) return
        await stripe.confirmSetup({
            elements,
            confirmParams: { return_url: window.location.href },
            redirect: 'always',
        })
    }

    return (
        <form onSubmit={handleSubmit}>
            <PaymentElement />
            <Button
                classes={'zr-mt-3'}
                hierarchy={'primary'}
                type={'submit'}
                text={t('subscription.add')}
            />
        </form>
    )
}

export default AddPaymentMethod
